import React, { useState, useEffect } from 'react';
import { AdminContext, useGetState, useMount } from '../../hooks';
import { MapContainer, TileLayer, Marker, Polyline, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import axios from 'axios';

import L from "leaflet";

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

export default function BoatMap({paths, markers}) {
    if (!paths) return null;

    let n = paths.length-1;
    let point = paths[n][paths[n].length-1];
    
    return (
        <MapContainer
            center={point} 
            zoom={13} 
            style={{ height: "100vh", width: "100%" }}
        >
            <TileLayer
                url="https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png"
                attribution='&copy; OpenStreetMap contributors'
            />
            {paths.map(points=><Polyline positions={points} color="#2F86CC" />)}
            {markers.map(marker => <Marker position={marker.pos}>
                <Popup>
                    <div>
                        <a
                            href={`https://www.google.com/maps?q=${marker.pos[0]},${marker.pos[1]}`}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {marker.pos[0].toFixed(5)}, {marker.pos[1].toFixed(5)}
                        </a>
                    </div>
                    <div className="dates">
                        From {new Date(marker.stamp[0]).toLocaleDateString('en-GB').slice(0, 8)} to {new Date(marker.stamp[1]).toLocaleDateString('en-GB').slice(0, 8)}
                    </div>
                </Popup>
            </Marker>)}
        </MapContainer>
    );
}